import React from "react";
import ListTable from "../../shared/ListTable";
import {useQuery} from "@apollo/client";
import {getBadIngredientsQuery} from "../../client/bad_ingredients/BadIngredientsQueries";
import Loader from "../../shared/Loader";

const ClientBadIngredientsList = ({ client }) => {
  const { data, loading } = useQuery(getBadIngredientsQuery, { variables: { clientId: client.id } })

  const header = <tr>
    <th>Ingredient</th>
    <th>Detalii</th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.ingredient.name}</td>
      <td>{item.details}</td>
    </tr>
  }

  if (loading) return <Loader />;

  return (
    <div className="row justify-content-md-center">
      <div className=" justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.badIngredients} header={header} listItem={listItem}
                     searchFields={['name', 'details']} />
        </div>
      </div>
    </div>
  )
}

export default ClientBadIngredientsList
